import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';

export const failedSendCreditTransactionsListColumns = [
  'failedSendCreditTransaction._id',
  'failedSendCreditTransaction.createdAt',
  'failedSendCreditTransaction.category',
  'failedSendCreditTransaction.language',
  'failedSendCreditTransaction.currency',
  'failedSendCreditTransaction.roundId',
  'failedSendCreditTransaction.transactionId',
  'failedSendCreditTransaction.operation',
  'failedSendCreditTransaction.reason',
  'failedSendCreditTransaction.providerId',
  'failedSendCreditTransaction.playerId',
  'failedSendCreditTransaction.amount',
  'failedSendCreditTransaction.multiplier',
  'failedSendCreditTransaction.gameId',
  'failedSendCreditTransaction.previousTransactionId',
  'failedSendCreditTransaction.awardId',
  'failedSendCreditTransaction.errorMessage',
  'failedSendCreditTransaction.isResolved',
] as const;

export type FailedSendCreditTransactionsListColumns =
  (typeof failedSendCreditTransactionsListColumns)[number];

export type FailedSendCreditTransactionsListFilter = {
  'failedSendCreditTransaction._id': string | undefined;
  'failedSendCreditTransaction.createdAt': string | undefined;
  'failedSendCreditTransaction.category': string | undefined;
  'failedSendCreditTransaction.language': string | undefined;
  'failedSendCreditTransaction.currency': string | undefined;
  'failedSendCreditTransaction.roundId': string | undefined;
  'failedSendCreditTransaction.transactionId': string | undefined;
  'failedSendCreditTransaction.operation': string | undefined;
  'failedSendCreditTransaction.reason': string | undefined;
  'failedSendCreditTransaction.providerId': string | undefined;
  'failedSendCreditTransaction.playerId': string | undefined;
  'failedSendCreditTransaction.amount': number | undefined;
  'failedSendCreditTransaction.multiplier': number | undefined;
  'failedSendCreditTransaction.gameId': number | undefined;
  'failedSendCreditTransaction.previousTransactionId': string | undefined;
  'failedSendCreditTransaction.awardId': string | undefined;
  'failedSendCreditTransaction.errorMessage': string | undefined;
  'failedSendCreditTransaction.isResolved': boolean | undefined;
};

export const defaultFailedSendCreditTransactionsListFilter: FailedSendCreditTransactionsListFilter =
  {
    'failedSendCreditTransaction._id': undefined,
    'failedSendCreditTransaction.createdAt': undefined,
    'failedSendCreditTransaction.category': undefined,
    'failedSendCreditTransaction.language': undefined,
    'failedSendCreditTransaction.currency': undefined,
    'failedSendCreditTransaction.roundId': undefined,
    'failedSendCreditTransaction.transactionId': undefined,
    'failedSendCreditTransaction.operation': undefined,
    'failedSendCreditTransaction.reason': undefined,
    'failedSendCreditTransaction.providerId': undefined,
    'failedSendCreditTransaction.playerId': undefined,
    'failedSendCreditTransaction.amount': undefined,
    'failedSendCreditTransaction.multiplier': undefined,
    'failedSendCreditTransaction.gameId': undefined,
    'failedSendCreditTransaction.previousTransactionId': undefined,
    'failedSendCreditTransaction.awardId': undefined,
    'failedSendCreditTransaction.errorMessage': undefined,
    'failedSendCreditTransaction.isResolved': undefined,
  };

export const failedSendCreditTransactionsListColumnVisibilitySettings = {
  'failedSendCreditTransaction._id': ColumnVisibilityType.Visible,
  'failedSendCreditTransaction.createdAt': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.category': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.language': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.currency': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.roundId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.transactionId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.operation': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.reason': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.providerId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.playerId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.amount': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.multiplier': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.gameId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.previousTransactionId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.awardId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.errorMessage': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTransaction.isResolved': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<FailedSendCreditTransactionsListColumns>;

export const defaultFailedSendCreditTransactionsListColumnVisibility =
  defaultColumnVisibilityParams(failedSendCreditTransactionsListColumnVisibilitySettings);

export const failedSendCreditTransactionsListColumnVisibilityOptions =
  defaultColumnVisibilityOptions(
    failedSendCreditTransactionsListColumns,
    failedSendCreditTransactionsListColumnVisibilitySettings
  );
